import { logger } from '../../common/logger'
import { XDActions } from '../../xd/actions'
import { XDTransmitter } from '../../xd/transmitter'
import { Store } from '../keys'
import { XDStorageRequest } from './request'

/**
 * Global (cross-domain) client side storage.
 *
 * NOTE: Use this for cross-property storage, and `LocalStore` for per-property.
 */
class XDStorage {
    protected xd: XDTransmitter

    /**
     * @param {string} xdSrc URL of cross domain receiver
     */
    constructor(xdSrc: string) {
        logger('debug', `XDStorage constructor with xdSrc = ${xdSrc}`)
        this.xd = new XDTransmitter(xdSrc)
    }

    public async delete(key: Store, timeoutMs?: number): Promise<boolean> {
        logger('debug', `XDStorage delete key = ${key} with timeoutMs = ${timeoutMs}, xdSrc = ${this.xd.xdOrigin}`)
        return this.xd.request(new XDStorageRequest(XDActions.DELETE, key), timeoutMs)
    }

    public async get<T>(key: Store, timeoutMs?: number): Promise<T> {
        logger('debug', `XDStorage get key = ${key} with timeoutMs = ${timeoutMs}, xdSrc = ${this.xd.xdOrigin}`)
        return this.xd.request(new XDStorageRequest(XDActions.GET, key), timeoutMs)
    }

    public async set<T>(
        key: Store,
        data: T,
        expireMs?: number,
        timeoutMs?: number): Promise<boolean> {
        logger('debug', `XDStorage set key = ${key}`,
                        `with data = ${JSON.stringify(data)}`,
                        `timeoutMs = ${timeoutMs}`,
                        `xdSrc = ${this.xd.xdOrigin}`)
        try {
            await this.xd.request(new XDStorageRequest<T>(XDActions.SET, key, data, expireMs), timeoutMs)
            return true
        } catch {
            return false
        }
    }
}

export const GlobalStore = new XDStorage(`${__webpack_public_path__}${__XD_HTML_FILENAME}`)
